module.exports = __webpack_public_path__ + "img/logo_hor.f632503d.png";